export class TimerHelper {
    static timer(timeOutMilliseconds: any, handler: any) {
        let timerId: number;
        if (timerId != null) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(handler, timeOutMilliseconds);
    }
}